var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustry04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414.4 195.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M127.42,152.29a3.63,3.63,0,0,0,3.62,3.62h7.24a3.63,3.63,0,0,0,3.62-3.62V90.74H127.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M135.86,43.27a7.29,7.29,0,0,0-6.05-3.21H38.13a7.21,7.21,0,0,0-6,3.21l-19.3,29a7.24,7.24,0,0,0,6,11.27H149.14a7.26,7.26,0,0,0,6-11.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M84,127H40.53V90.74H26.05v57.93a7.23,7.23,0,0,0,7.24,7.24H91.21a7.23,7.23,0,0,0,7.24-7.24V90.74H84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M213.23,47.87H196.39l6.21-18.94a3.51,3.51,0,0,0-3.38-4.41h-21a3.5,3.5,0,0,0-3.47,3l-4.67,35a3.51,3.51,0,0,0,3.47,4h17.33l-6.73,28.39a3.5,3.5,0,0,0,6.43,2.55l25.69-44.36A3.5,3.5,0,0,0,213.23,47.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M274.07,47.87H257.23l6.22-18.94a3.52,3.52,0,0,0-3.39-4.41h-21a3.5,3.5,0,0,0-3.47,3l-4.67,35a3.5,3.5,0,0,0,3.47,4H251.7L245,94.94a3.5,3.5,0,0,0,6.43,2.55L277.1,53.13A3.51,3.51,0,0,0,274.07,47.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M334.92,47.87H318.08l6.22-18.94a3.52,3.52,0,0,0-3.39-4.41h-21a3.52,3.52,0,0,0-3.48,3l-4.67,35a3.52,3.52,0,0,0,3.48,4h17.32l-6.73,28.39a3.5,3.5,0,0,0,6.44,2.55l25.68-44.36A3.5,3.5,0,0,0,334.92,47.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M395.77,47.87H378.93l6.21-18.94a3.51,3.51,0,0,0-3.38-4.41h-21a3.5,3.5,0,0,0-3.47,3l-4.67,35a3.51,3.51,0,0,0,3.47,4H373.4l-6.73,28.39a3.5,3.5,0,0,0,6.43,2.55l25.69-44.36A3.5,3.5,0,0,0,395.77,47.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry04);
export default __webpack_public_path__ + "static/media/industry_04.74c9659b.svg";
export { ForwardRef as ReactComponent };